import { render, staticRenderFns } from "./ReporteLuminariaPorPotenciaTecnologiaChart.vue?vue&type=template&id=24b7c40e"
import script from "./ReporteLuminariaPorPotenciaTecnologiaChart.vue?vue&type=script&lang=js"
export * from "./ReporteLuminariaPorPotenciaTecnologiaChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports